import { useEffect, useState } from 'react';
import {
  Table,
  ScrollArea,
  Badge,
  Loader,
  Center,
  Text,
  Box,
  Stack,
  Pagination
} from '@mantine/core';
import useStyles from './style';
import edit from '../../../assets/icons/edit.svg';
import { Modal, Button, Group } from '@mantine/core';
import { getHeader, getUserData } from '../../../config/userSession';
import { noRecordFound } from '../../../utils/const';

const statusColors = {
  PENDING: 'yellow',
  APPROVED: 'green',
  REJECTED: 'red'
};

export default function AccessRequestTable() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const { classes } = useStyles(useStyles);
  const [opened, setOpened] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [status, setStatus] = useState('');
  const [activePage, setActivePage] = useState(1);
  const user = getUserData();
  console.log(user);
  const [entries, setEntries] = useState([]);
  const [pageLoadEntries, setPageLoadEntries] = useState([]);
  const [totalPage, setTotalPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  console.log(selectedRequest);
  const pageChangeHandler = (page) => {
    setActivePage(page);
  };
  const fetchRequests = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/access/access-request?page=${activePage}&email=${user.email}&pSize=${pageSize}`
      );
      const data = await res.json();
      console.log(data);
      setRequests(data?.data);
      setTotalPage((data.totalCount + pageSize - 1) / pageSize);

      console.log(data);
    } catch (error) {
      console.error('Failed to fetch access requests:', error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    // Fetch all access requests

    fetchRequests();
  }, [activePage]);

  const formatDate = (isoString) => {
    const date = new Date(isoString); // Define date here

    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;

    const formatted = `${month}/${day}/${year} ${hours}:${minutes}:${seconds} ${ampm}`;
    return formatted;
  };
  const handleStatusUpdate = async (newStatus) => {
    setUpdating(true);
    console.log(newStatus);
    setStatus(newStatus === 'APPROVED' ? 'Approving' : 'Rejecting');

    try {
      let newattributeName;

      switch (selectedRequest.accessName) {
        case 'IDP':
          newattributeName = 'idp_access';
          break;
        case 'Assistant':
          newattributeName = 'assistant_access';
          break;

        case 'STRIPE ACCOUNT':
          newattributeName = 'stripe_access';
          break;
      }
      await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/account/send-access-request`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            ...getHeader()
          },
          body: JSON.stringify({
            email: selectedRequest.email,
            attributeName: newattributeName,
            value: newStatus
          })
        }
      );
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/access/update-access-request/${selectedRequest.id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            ...getHeader()
          },
          body: JSON.stringify({
            status: newStatus,
            email: selectedRequest.email,
            attributeName: selectedRequest.accessName
          })
        }
      );

      if (response.status == 200) {
        setOpened(false);
        setUpdating(false);
        setStatus(newStatus);

        await fetchRequests();
      }
    } catch (err) {
      console.error(err);
      setUpdating(false);
    }
  };

  const rows = requests.map((request) => (
    <tr key={request.id}>
      <td>{request.id}</td>

      <td>{request.email}</td>
      <td>{request.accessName}</td>
      <td>
        <Badge color={statusColors[request.status]} variant="light">
          {request.status}
        </Badge>
      </td>
      <td>{formatDate(request.createdAt)}</td>
      <td className={classes.subtableData}>
        <Box className={classes.editAndView}>
          <img
            className={
              request.status === 'PENDING' ? classes.action : classes.inaction
            }
            src={edit}
            alt="edit"
            onClick={
              request.status === 'PENDING'
                ? () => {
                    setSelectedRequest(request);
                    setOpened(true);
                  }
                : undefined // No click handler if not pending
            }
          />
        </Box>
      </td>
    </tr>
  ));

  return (
    <Box className={classes.wrapper}>
      {' '}
      <ScrollArea>
        <Box className={classes.wrapper}>
          {' '}
          <Box className={classes.headerAndSearch}>
            <p className={classes.title}>Access Requests</p>
          </Box>{' '}
          <Box className={classes.tableContainer}>
            {' '}
            <Table className={classes.table}>
              <thead className={classes.tableHead}>
                <tr>
                  <th className={classes.columnHeading}>Id</th>
                  <th className={classes.columnHeading}>Email</th>
                  <th className={classes.columnHeading}>Access Name</th>
                  <th className={classes.columnHeading}>Status</th>
                  <th className={classes.columnHeading}>Date Requested</th>
                  <th className={classes.columnHeading}>Action</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="3">
                      <Center p="md">
                        <Loader size="sm" />
                      </Center>
                    </td>
                  </tr>
                ) : requests.length === 0 ? (
                  <tr>
                    <td colSpan="3">
                      <Center p="md">
                        <Text>No access requests found</Text>
                      </Center>
                    </td>
                  </tr>
                ) : (
                  rows
                )}
              </tbody>
            </Table>
          </Box>
          {rows.length === 0 ? (
            <p className="no-record-found"> {noRecordFound} </p>
          ) : (
            <Pagination
              size={'md'}
              defaultValue={activePage}
              onChange={pageChangeHandler}
              className={classes.pagination}
              siblings={1}
              total={totalPage}
            />
          )}
        </Box>
        <Modal
          opened={opened}
          onClose={() => setOpened(false)}
          title="Approve or Reject Request"
          centered
          size="md" // Control modal width (sm, md, lg, xl, or number in px)
          overlayProps={{ blur: 2 }} // Optional: Adds a slight blur to the background
          radius="md" // Rounded corners
        >
          {selectedRequest && (
            <Stack spacing="sm">
              {' '}
              {/* Better vertical spacing between elements */}
              <Text size="sm">
                Email:{' '}
                <Text span weight={600}>
                  {selectedRequest.email}
                </Text>
              </Text>
              <Text size="sm">
                Access:{' '}
                <Text span weight={600}>
                  {selectedRequest.accessName}
                </Text>
              </Text>
              <Text size="sm">
                Status:
                <Badge
                  color={
                    selectedRequest.status === 'APPROVED'
                      ? 'green'
                      : selectedRequest.status === 'REJECTED'
                      ? 'red'
                      : 'blue'
                  }
                  ml="sm"
                  variant="filled"
                >
                  {selectedRequest.status}
                </Badge>
              </Text>
              <Group mt="xl" position="right">
                {' '}
                {/* Align buttons to the right */}
                <Button
                  color="red"
                  disabled={updating}
                  variant="outline"
                  onClick={() => handleStatusUpdate('REJECTED')}
                >
                  {updating && status === 'REJECTED' ? status : 'Reject'}
                </Button>
                <Button
                  disabled={updating}
                  color="green"
                  onClick={() => handleStatusUpdate('APPROVED')}
                >
                  {updating && status === 'APPROVED' ? status : 'Approve'}
                </Button>
              </Group>
            </Stack>
          )}
        </Modal>
      </ScrollArea>
    </Box>
  );
}
